import {VueContentPopover} from "@/app/popover/VueContentPopover";
import EnterContactDataForm from "@/components/pay/EnterContactDataForm.vue";
import { translations } from "@/shared/localization/translations";

export class EnterContactInfoContentPopover extends VueContentPopover {
    constructor(isInOperatorApp: boolean) {
        super({ popoverClass: "enter-contact-info", title: translations.enterContactDataPopover.title, fullscreen: false });

        this.initComponent(EnterContactDataForm, {
            hide: () => {
                this.hide();
            },
            isInOperatorApp: isInOperatorApp,
        });
    }


}